import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSalesOrderDetail, getDescibe, fetchGuestList, fetchGuestDetail, fetchAgentDetail } from "./actions";
import GuestList from "./Steps/stepGuest";
import Step1 from "./Steps/step1";
import Step2 from "./Steps/step2";
import Step3 from "./Steps/step3";
import Step4 from "./Steps/step4";
import StepSummary from "./Steps/stepSummary";
import StepFinish from "./Steps/stepFinish";
import Sidebar from "../../components/global/Sidebar/vf2";
import Content from "../../components/dashboard/general/Content";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import LoadingOverlay from "./Components/Loading/LoadingOverlay";
import "./styles.scss";

const { URL_PREFIX } = window;
const mainContact = true

class VF2Wizard extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  async componentWillMount() {
    try {
      this.setState({ loading: true });
      await this.props.fetchGuestDetail()
      await this.props.fetchAgentDetail()
      await this.props.fetchGuestList()
      this.setState({ loading: false });
      await this.props.getDescibe()
    } catch (error) {

    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { mainGuest, guestList } = this.props.vf2;
    if (!guestList) {
      return (
        <p className="text-center">
          <i className="fa fa-circle-notch fa-spin fa-4x loading" />
        </p>
      );
    }

    return (
      <>
        <LoadingOverlay
          isLoading={this.state.loading}
        />
        <Router>
          <Sidebar mainContact={mainGuest}/>
          <Content style={{ backgroundColor: "White" }}>
            <Switch>
             <Route
                path={`${URL_PREFIX}/vf2/wizard`}
                render={(props) => mainGuest ? 
                  <GuestList {...props} mainContact={mainGuest} /> : 
                  <Step1 {...props} mainContact={mainGuest} />}
                exact
              />
              {mainGuest && (
                <Route
                  path={`${URL_PREFIX}/vf2/wizard/personal`}
                  render={(props) => <Step1 {...props} mainContact={mainGuest} />}
                  exact
                />
              )}
              <Route
                path={`${URL_PREFIX}/vf2/wizard/diving`}
                render={(props) => <Step2 {...props} mainContact={mainGuest} />}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf2/wizard/stay`}
                render={(props) => <Step3 {...props} mainContact={mainGuest} />}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf2/wizard/flight`}
                render={(props) => <Step4 {...props} mainContact={mainGuest} />}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf2/wizard/summary`}
                render={(props) => <StepSummary {...props} mainContact={mainGuest} />}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf2/wizard/finish`}
                render={(props) => <StepFinish {...props} mainContact={mainGuest} />}
                exact
              />
            </Switch>
          </Content>
        </Router >
      </>
    );
  }
}

VF2Wizard.propTypes = {
  getSalesOrderDetail: PropTypes.func.isRequired,
  fetchGuestList: PropTypes.func.isRequired,
  fetchGuestDetail: PropTypes.func.isRequired,
  fetchAgentDetail: PropTypes.func.isRequired,
  getDescibe: PropTypes.func.isRequired,
  vf2: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesOrderDetail,
      getDescibe,
      fetchGuestList,
      fetchGuestDetail,
      fetchAgentDetail,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF2Wizard);
